module.exports = __webpack_public_path__ + "static/media/edit.3d536247.svg";